import VueTypes from 'vue-types';
import icons from '@ridi/rsg/svg/icons.json';

const Icon = {
  functional: true,
  props: {
    name: VueTypes.string.isRequired,
  },
  render (h, { props, data }) {
    const name = props.name.replace(/_\d+/, '');
    const icon = icons[props.name] || [];
    const viewBox = `0 0 ${icon[0]} ${icon[1]}`;
    const contents = icon[2];
    return (
      <svg
        class={['ridi_icon', name, props.name]}
        viewBox={viewBox}
        domPropsInnerHTML={contents}
        {...data}
      />
    );
  },
};

export default {
  install (Vue) {
    Vue.component('ridi-icon', Icon);
  },
};



// WEBPACK FOOTER //
// ./common/plugins/icon.js